import React, { useState, useEffect } from "react";
import Table from "../../../components/UI/table";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import axios from "axios";
import { useTranslation } from "react-i18next";

function PurchaseHistory() {
  const [purchaseHistoryList, setPurchaseHistoryList] = useState([]);
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const apiUrl = process.env.REACT_APP_API_URL;
  const { t } = useTranslation();

  useEffect(() => {
    const fetchPurchaseHistoryList = async () => {
      if (!userInfo?.access || !apiUrl) return;

      try {
        const config = {
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${userInfo.access}`,
          },
        };

        const { data } = await axios.get(
          `${apiUrl}/api/merchant/get-purchase-history-list/`,
          config
        );

        setPurchaseHistoryList(data);
      } catch (error) {
        console.error("Error fetching purchase history:", error);
      }
    };

    fetchPurchaseHistoryList();
  }, [userInfo, apiUrl]);

  const deletePurchaseHistoryHandler = async (id) => {
    if (!userInfo?.access || !apiUrl) return;

    const config = {
      headers: {
        "Content-type": "application/json",
        Authorization: `Bearer ${userInfo.access}`,
      },
    };

    try {
      await axios.delete(
        `${apiUrl}/api/merchant/delete-purchase-history/${id}/`,
        config
      );

      setPurchaseHistoryList((prevList) =>
        prevList.filter((item) => item.id !== id)
      );
    } catch (error) {
      console.error("Error deleting purchase history:", error);
    }
  };

  return (
    <div className="content-page">
      <div className="content">
        <div className="container-fluid">
          <br />
          <div className="page-title-and-bnt">
            <h1>{t("purchaseHistory.header")}</h1>
            {userInfo && userInfo.is_admin && (
              <LinkContainer to="/add-purchase-history/">
                <Button variant="success">
                  {t("purchaseHistory.AddPurchase")}
                </Button>
              </LinkContainer>
            )}
          </div>
          <br />

          <Table variant="striped" stickyHeader>
            <thead>
              <tr>
                <th>{t("businesses.ID")}</th>
                <th>{t("purchaseHistory.Client")}</th>
                <th>{t("purchaseHistory.Date")}</th>
                <th>{t("purchaseHistory.Time")}</th>
                <th>{t("purchaseHistory.TotalAmount")}</th>
                {userInfo && userInfo.is_admin && (
                  <th>{t("usersLists.Options")}</th>
                )}
              </tr>
            </thead>

            <tbody>
              {purchaseHistoryList.map((history) => {
                const datePart = history.date.split("T")[0];
                const timePart = history.date.split("T")[1].split(":");
                const formattedTime = `${timePart[0]}:${timePart[1]}`;

                return (
                  <tr key={history.id}>
                    <td>{history.id}</td>
                    <td>{history.client_id.name}</td>
                    <td>{datePart}</td>
                    <td>{formattedTime}</td>
                    <td>{history.total_amount}</td>

                    {userInfo && userInfo.is_admin && (
                      <td>
                        <div className="users-list-btn">
                          <LinkContainer
                            to={`/edit-purchase-history/${history.id}/`}
                          >
                            <Button variant="info">
                              {t("loyaltyView.Edit")}
                            </Button>
                          </LinkContainer>
                          <Button
                            variant="danger"
                            onClick={() =>
                              deletePurchaseHistoryHandler(history.id)
                            }
                          >
                            {t("usersLists.Delete")}
                          </Button>
                        </div>
                      </td>
                    )}
                  </tr>
                );
              })}
            </tbody>
          </Table>

          {userInfo && userInfo.is_admin && (
            <div className="mt-4">
              <LinkContainer to="/add-purchase-history/">
                <Button variant="primary">
                  {t("purchaseHistory.AddPurchase")}
                </Button>
              </LinkContainer>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default PurchaseHistory;